import { News } from './news/news';
import { Sources } from './sources/sources';
import { NewsData, SourcesData, Message, Article, Source } from '../../types/interfaces';
import { MESSAGES } from "../../types/MESSAGES";

export class AppView {
  public news: News;
  public sources: Sources;
    constructor() {
        this.news = new News();
        this.sources = new Sources();
    }

    static showInfo(data: Message):void {
      (document.querySelector('.info-header-normal') as HTMLElement).textContent = data.normalText;
      (document.querySelector('.info-header-accent') as HTMLElement).textContent = data.accentText;
      (document.querySelector('.info-header-accent') as HTMLElement).style.color = data.accentColor;
      (document.querySelector('.info-description') as HTMLElement).textContent = data.description;
  }

    drawNews(data: NewsData):void {
        const values:Array<Article> = data.articles ? data.articles : [];
        if (values.length === 0) {
            AppView.showInfo(MESSAGES.NoNews);
        } else {
            AppView.showInfo(MESSAGES.ShowNews);
        }
        this.news.draw(values);
    }

    drawSources(data: SourcesData):void {
        const values:Array<Source> = data.sources ? data.sources : [];
        AppView.showInfo(MESSAGES.Hello);
        if (values.length === 0) {
            AppView.showInfo(MESSAGES.NoSources);
        }
        this.sources.draw(values);
    }
}
